'use-strict';

import { IScope } from 'angular';
import { SettingsAPIService } from '../../../shared/api/settings-api.service';
import { ConfigService } from '../../../shared/config/config.service';
import { InterfaceService } from '../../../shared/interface/interface.service';
import { EExternalAPI } from '../../../src/app/@shared-types/api';
import { DATAPIConfig } from '../../../src/app/@shared-types/api/dat';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../../ui-components/toast/toast.service';

/* @ngInject */
export default class DATAPIController {
  private $scope: IScope;

  public datAPIConfig: DATAPIConfig | null = null;

  public importing = false;

  private settingsApiService: SettingsAPIService;

  private interfaceService: InterfaceService;

  private toastService: ToastService;

  private logService: LogService;

  public notificationAdmins: string | null = null;

  constructor(
    $scope: IScope,
    settingsApiService: SettingsAPIService,
    interfaceService: InterfaceService,
    toastService: ToastService,
    configService: ConfigService,
    logService: LogService,
  ) {
    this.settingsApiService = settingsApiService;
    this.interfaceService = interfaceService;
    this.$scope = $scope;
    this.toastService = toastService;
    this.logService = logService;

    this.getSchwackeConfig();
  }

  private getSchwackeConfig = async (): Promise<void> => {
    const configs = await this.settingsApiService
      .getAPIConfig<DATAPIConfig[]>(EExternalAPI.DAT).catch();

    [this.datAPIConfig] = configs;
    this.interfaceService.applyScope(this.$scope);
  };

  public updateConfig = async (
    config: unknown,
  ): Promise<void> => {
    if (!this.datAPIConfig) return;
    const { useOwnAccount } = this.datAPIConfig;

    const processedConfig: DATAPIConfig = {
      enabled: this.datAPIConfig.enabled,
      useOwnAccount: this.datAPIConfig.useOwnAccount,
      account: {
        // eslint-disable-next-line max-len
        customerNumber: useOwnAccount ? parseInt(String(this.datAPIConfig.account.customerNumber), 10) : 0,
        password: useOwnAccount ? this.datAPIConfig.account.password : '',
        user: useOwnAccount ? this.datAPIConfig.account.user : '',
      },
    };

    await this.settingsApiService.updateAPIConfig(EExternalAPI.DAT, processedConfig)
      .then(() => this.toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert.'));
  };
}
